<script setup lang="ts">
import { NxtMainLayout, NxtSidebar, NxtSidebarNavigationItem } from '@future-harry/nxt-styles';
import { ModuleKey } from '@future-harry/nxt-vue-library';
import { storeToRefs } from 'pinia';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useUserInfoStore } from '@/core/collections/user-info/user-info.store';
import PageHeader from '@/core/components/layout-elements/PageHeader.vue';
import UserSettings from '@/apps/admin/components/side-modals/user-settings/UserSettings.vue';
import { http } from '@/core/helpers/axiosHelper';
import { useApp } from '@/core/hooks/useApp';

const { t } = useI18n();
const { handleUserChange, handleLocaleChange } = useApp();

//#region Locale
const { locale } = useI18n();
watch(locale, handleLocaleChange, { immediate: true });
//#endregion

//#region User change
const { userInfo } = storeToRefs(useUserInfoStore());
// @ts-ignore
watch(userInfo, handleUserChange, { immediate: true });
//#endregion

const navigationItems = computed<Array<NxtSidebarNavigationItem>>(() => [
   {
      key: 'jobsites',
      icon: 'fas fa-globe',
      label: t('jobsites.jobsites', 2),
      to: { name: 'JobsitesOverview' },
   },
]);

const showSettingsPanel = ref(false);
function handleShowSettingsPanel() {
   showSettingsPanel.value = true;
}
</script>

<template>
   <NxtMainLayout :http="http" class="app">
      <template #nav>
         <NxtSidebar :module-key="ModuleKey.NxtJob" :navigationItems :shared-routes="[]" />
      </template>
      <template #header>
         <PageHeader @on-show-settings-panel="handleShowSettingsPanel" />
      </template>

      <RouterView v-slot="{ Component }">
         <Transition name="fade" mode="out-in">
            <component :is="Component" />
         </Transition>
      </RouterView>
   </NxtMainLayout>
   <Transition name="fade">
      <UserSettings v-if="showSettingsPanel" @on-close-settings="showSettingsPanel = false" />
   </Transition>
</template>

<style src="@future-harry/nxt-styles/dist/style.css"></style>
<style lang="scss">
:root {
   --nxt-main: var(--nxt-job-main);
   --nxt-main-hover: var(--nxt-job-hover);
   --nxt-main-light: var(--nxt-job-light);
   --nxt-main-highlight: var(--nxt-job-highlight);
   --nxt-main-pressed: var(--nxt-job-pressed);
}

.app {
   height: 100vh;
   background-color: var(--nxt-extralight-grey);
}
</style>
